import { Icon } from '../icons';
import { formatDate, labelKind } from '../utils';
import { StatusDot } from './Status';

export function SearchResults({ query, loading, results, onSelect }) {
  return (
    <main className="search-results page-view">
      <header className="page-heading">
        <p>Search</p>
        <h1>{loading ? 'Searching your memory…' : `${results.length} matches`}</h1>
        <span>Results for “{query}” across the registry, rollouts, skills, and source notes.</span>
      </header>
      <div className="search-results__list">
        {!loading && !results.length ? <div className="empty-state empty-state--large"><Icon name="search" size={30}/><h2>No memories found</h2><p>Try a project, command, model, host, or phrase you remember.</p></div> : null}
        {results.map((result) => (
          <button key={`${result.kind}-${result.id}`} onClick={() => onSelect(result)}>
            <span className="search-result__icon"><Icon name={result.kind === 'skill' ? 'skills' : result.kind === 'group' ? 'knowledge' : 'document'} size={19}/></span>
            <span className="search-result__body"><small>{labelKind(result.kind)} · {result.path}</small><strong>{result.title}</strong><p>{result.snippet}</p></span>
            <span className="search-result__meta"><StatusDot status={result.status}/><time>{formatDate(result.updatedAt, { year: false })}</time><Icon name="chevron" size={15}/></span>
          </button>
        ))}
      </div>
    </main>
  );
}
